<template>
  <div class="page-wrapper thu-chi-user-wrapper">
    <div class="content container-fluid d-flex justify-content-center">
      <div class="thu-chi-user">
        <div class="thu-chi-body">
          <component :is="activeComponent" />
        </div>

        <!-- Bottom Tab -->
        <nav class="thu-chi-bottom-nav">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            type="button"
            class="nav-item"
            :class="{ active: activeTab === tab.key }"
            @click="setActiveTab(tab.key)"
          >
            <i :class="tab.icon"></i>
            <span>{{ tab.label }}</span>
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import ThuChiNhapVao from "./ThuChiNhapVao.vue"
import ThuChiLich from "./ThuChiLich.vue"
import ThuChiSoGiaoDich from "./ThuChiSoGiaoDich.vue"
import ThuChiThongKeUser from "./ThuChiThongKeUser.vue"

const tabs = [
  { key: "nhap-vao", label: "Nhập vào", icon: "la la-edit" },
  { key: "lich", label: "Lịch", icon: "la la-calendar" },
  { key: "so-giao-dich", label: "Sổ GD", icon: "la la-list-alt" },
  { key: "thong-ke", label: "Thống kê", icon: "la la-pie-chart" }
]

const activeTab = ref("nhap-vao")

const activeComponent = computed(() => {
  switch (activeTab.value) {
    case "nhap-vao":
      return ThuChiNhapVao
    case "lich":
      return ThuChiLich
    case "so-giao-dich":
      return ThuChiSoGiaoDich
    case "thong-ke":
      return ThuChiThongKeUser
    default:
      return ThuChiNhapVao
  }
})

function setActiveTab(key) {
  activeTab.value = key
}
</script>

<style scoped>
.thu-chi-user-wrapper {
  background: #f6f8fb;
  min-height: 100vh;
}

.thu-chi-user {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  max-width: 100%;
  background: #f6f8fb;
  position: relative;
}

/* Mobile First */
.thu-chi-body {
  flex: 1;
  width: 100%;
  padding: 8px 8px 72px;
  overflow-y: auto;
}

/* Bottom tab - Mobile */
.thu-chi-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #eee;
  background: #fff;
  padding: 6px 4px calc(6px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

.thu-chi-bottom-nav .nav-item {
  flex: 1;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 11px;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 0;
  min-height: 50px;
}

.thu-chi-bottom-nav .nav-item i {
  font-size: 18px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.thu-chi-bottom-nav .nav-item.active {
  color: #ff8b00;
  font-weight: 600;
}

.thu-chi-bottom-nav .nav-item.active i {
  color: #ff8b00;
  transform: scale(1.1);
}

/* Tablet */
@media (min-width: 768px) and (max-width: 1199px) {
  .thu-chi-user {
    max-width: 90%;
    margin: 0 auto;
    height: 95vh;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.1);
    margin-top: 2vh;
    margin-bottom: 2vh;
  }
  
  .thu-chi-body {
    padding: 16px 16px 80px;
  }
  
  .thu-chi-bottom-nav {
    position: absolute;
    border-radius: 0 0 16px 16px;
    padding: 8px 4px;
  }
  
  .thu-chi-bottom-nav .nav-item {
    font-size: 12px;
    min-height: 55px;
  }
  
  .thu-chi-bottom-nav .nav-item i {
    font-size: 20px;
  }
}

/* Desktop */
@media (min-width: 1200px) {
  .thu-chi-user {
    max-width: 800px;
    height: 90vh;
    border-radius: 20px;
    box-shadow: 0 12px 48px rgba(0,0,0,0.15);
    margin-top: 5vh;
    margin-bottom: 5vh;
    overflow: hidden;
  }
  
  .thu-chi-body {
    padding: 20px 20px 80px;
  }
  
  .thu-chi-bottom-nav {
    position: absolute;
    border-radius: 0;
    padding: 10px 4px;
  }
  
  .thu-chi-bottom-nav .nav-item {
    font-size: 13px;
    min-height: 60px;
    transition: all 0.3s ease;
  }
  
  .thu-chi-bottom-nav .nav-item:hover {
    background: rgba(255, 139, 0, 0.05);
    border-radius: 8px;
  }
  
  .thu-chi-bottom-nav .nav-item i {
    font-size: 22px;
  }
}

/* Large Desktop */
@media (min-width: 1400px) {
  .thu-chi-user {
    max-width: 900px;
  }
}

/* X-Small devices */
@media (max-width: 375px) {
  .thu-chi-body {
    padding: 6px 6px 68px;
  }
  
  .thu-chi-bottom-nav .nav-item {
    font-size: 10px;
    min-height: 48px;
  }
  
  .thu-chi-bottom-nav .nav-item i {
    font-size: 16px;
  }
}

/* Landscape mode */
@media (max-height: 500px) and (orientation: landscape) {
  .thu-chi-user {
    height: 100vh;
  }
  
  .thu-chi-bottom-nav {
    padding: 4px 4px calc(4px + env(safe-area-inset-bottom));
  }
  
  .thu-chi-bottom-nav .nav-item {
    min-height: 44px;
    flex-direction: row;
    gap: 4px;
  }
  
  .thu-chi-bottom-nav .nav-item i {
    margin-bottom: 0;
    font-size: 16px;
  }
}
</style>
